var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCoraMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 32,
    viewBox: "0 0 139 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1067 0H10.5625V10.6667H21.1067V0Z",
    fill: "#FF8900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1067 21.332H10.5625V31.9988H21.1067V21.332Z",
    fill: "#FF8900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5676 10.668H0.0234375V21.3347H10.5676V10.668Z",
    fill: "#FF8900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6575 0H21.1133V10.6667H31.6575V0Z",
    fill: "#FF8900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6575 21.332H21.1133V31.9988H31.6575V21.332Z",
    fill: "#FF8900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0862 31.9999H10.5977V21.3613",
    fill: "#FFA922"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5977 10.6386V0H21.0862",
    fill: "#FFA922"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1367 0H31.6531V10.6386",
    fill: "#FFA922"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0546875 10.668H10.5711V21.3066",
    fill: "#FFA922"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6531 21.3613V31.9999H21.1367",
    fill: "#FFA922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCoraMini);
export default __webpack_public_path__ + "static/media/logo_cora_mini.fb2e32e8677536d04d3995b9076a2f7f.svg";
export { ForwardRef as ReactComponent };